import amazonSellerAccounts from './amazonSellerAccounts'
import languages from './languages'
import alipay from './alipay'

export default {
  ...amazonSellerAccounts,
  ...languages,
  ...alipay
}
